import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API() + 'bilety/jendorazowe/';

export default {

    dodajZamowienieBiletyJednorazowe(data){
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    }


}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyApi/ClientBiletyService.js